import Modal from 'bootstrap/js/dist/modal';

export default class BootstrapModal {

    static init() {
        const queryParams = new URLSearchParams(window.location.search);

        if (queryParams.has('open-modal')) {
            const modalElement = document.getElementById(queryParams.get('open-modal'));

            if (! modalElement) {
                return;
            }

            const modalObject = Modal.getOrCreateInstance(modalElement);

            if (! modalObject) {
                return;
            }

            modalObject.show();
        }

        window.addEventListener('modal:close', (event) => {
            const modalElement = document.getElementById(event.detail.modal);

            if (! modalElement) {
                return;
            }

            const modalObject = Modal.getOrCreateInstance(modalElement);

            if (! modalObject) {
                return;
            }

            modalObject.hide();
        });
    }

}
